import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Typography from '@mui/material/Typography'
import { FC, ReactNode } from 'react'

export interface ValuePropProps {
  icon: IconProp
  iconMargin?: string
  title: ReactNode
  description: ReactNode
}

const ValueProp: FC<ValuePropProps> = ({ icon, title, description, iconMargin = '0px' }) => (
  <>
    <Typography variant="h2" className="pb-2 md:pb-6" sx={{ ml: { md: iconMargin } }}>
      <FontAwesomeIcon icon={icon} className="text-green-600" />
    </Typography>
    <div className="flex flex-col gap-2">
      <Typography variant="h4">{title}</Typography>
      <Typography variant="p2">{description}</Typography>
    </div>
  </>
)

export default ValueProp
